import React from 'react'
import clients from '../../collectionsStructure/trading-clients'
import partners from '../../collectionsStructure/trading-partners'
import suppliers from '../../collectionsStructure/trading-suppliers'
import product_nav from './views/products/_nav'

import { CNavGroup, CNavItem } from '@coreui/react'

import _modules from '../../_modules'
import purchase_orders from '../../collectionsStructure/trading-purchase_orders'
import sales_orders from '../../collectionsStructure/trading-sales_orders'
import sales_quotations from '../../collectionsStructure/trading-sales_quotations'
import sales_invoices from '../../collectionsStructure/trading-sales_invoices'
import sales_receipts from '../../collectionsStructure/trading-sales_receipts'
import contracts from '../../collectionsStructure/trading-contracts'
import commission from '../../collectionsStructure/trading-commissions'
import terms_and_conditions from '../../collectionsStructure/trading-terms_and_conditions'
import returns from '../../collectionsStructure/trading-returns'

const trading_items = {
  component: CNavGroup,
  name: 'Trading',
  icon: <i className="material-icons-outlined">business_center</i>,
  items: [],
}
let output = []

if (_modules.clients) {
  trading_items.items.push({
    component: CNavItem,
    name: 'External Parties',
    to: '/clients',
    permissionSource: clients.permissionSource,
    icon: <i className="material-icons-outlined">assured_workload</i>,
  })
} else if (_modules.partners) {
  trading_items.items.push({
    component: CNavItem,
    name: 'External Parties',
    to: '/partners',
    permissionSource: partners.permissionSource,
    icon: <i className="material-icons-outlined">assured_workload</i>,
  })
} else if (_modules.suppliers) {
  trading_items.items.push({
    component: CNavItem,
    name: 'External Parties',
    to: '/suppliers',
    permissionSource: suppliers.permissionSource,
    icon: <i className="material-icons-outlined">assured_workload</i>,
  })
}

trading_items.items.push(...product_nav)
if (
  _modules.purchase_orders ||
  _modules.sales_orders ||
  _modules.contracts ||
  _modules.sales_quotations ||
  _modules.returns ||
  _modules.commissions ||
  _modules.terms_and_conditions
) {
  if (_modules.purchase_orders) {
    trading_items.items.push({
      component: CNavItem,
      name: 'Purchase Services',
      to: '/purchase-orders',
      permissionSource: purchase_orders.permissionSource,
      icon: <i className="material-icons-outlined">request_quote</i>,
    })
  }

  if (_modules.sales_orders) {
    trading_items.items.push({
      component: CNavItem,
      name: 'Sales Services',
      to: '/sales-orders',
      permissionSource: sales_orders.permissionSource,
      icon: <i className="material-icons-outlined">attach_money</i>,
    })
  } else if (_modules.sales_quotations) {
    trading_items.items.push({
      component: CNavItem,
      name: 'Sales Services',
      to: '/sales-quotations',
      permissionSource: sales_quotations.permissionSource,
      icon: <i className="material-icons-outlined">attach_money</i>,
    })
  } else if (_modules.sales_invoices) {
    trading_items.items.push({
      component: CNavItem,
      name: 'Sales Services',
      to: '/sales-invoices',
      permissionSource: sales_invoices.permissionSource,
      icon: <i className="material-icons-outlined">attach_money</i>,
    })
  } else if (_modules.sales_receipts) {
    trading_items.items.push({
      component: CNavItem,
      name: 'Sales Services',
      to: '/sales-receipts',
      permissionSource: sales_receipts.permissionSource,
      icon: <i className="material-icons-outlined">attach_money</i>,
    })
  } else if (_modules.contracts) {
    trading_items.items.push({
      component: CNavItem,
      name: 'Sales Services',
      to: '/contracts',
      permissionSource: contracts.permissionSource,
      icon: <i className="material-icons-outlined">attach_money</i>,
    })
  }

  if (_modules.returns)
    trading_items.items.push({
      component: CNavItem,
      name: 'Return',
      to: '/returns',
      permissionSource: returns.permissionSource,
      icon: <i className="material-icons-outlined">assignment_returned</i>,
    })

  if (_modules.commissions)
    trading_items.items.push({
      component: CNavItem,
      name: 'Commissions',
      to: '/commissions',
      permissionSource: commission.permissionSource,
      icon: <i className="material-icons-outlined">money_off</i>,
    })
  if (_modules.terms_and_conditions)
    trading_items.items.push({
      component: CNavItem,
      name: 'Terms And Conditions',
      to: '/terms-and-conditions',
      permissionSource: terms_and_conditions.permissionSource,
      icon: <i className="material-icons-outlined">drive_file_rename_outline</i>,
    })
}

if (trading_items.items.length) output.push(trading_items)

export default output
